import { BehindProviderFeatureAccessCheck } from '~/shared/ui'

import { Box } from '@mui/material'
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutlineOutlined'
import CalendarToday from '@mui/icons-material/CalendarToday'
import type { FC } from 'react'
import FaceIcon from '@mui/icons-material/Face'
import FormatListBulletedIcon from '@mui/icons-material/FormatListBulleted'
import { NavLink } from 'react-router'
import { useFeatureAccess } from '~/shared/hooks/useFeatureAccess'
import { useLocalStorage } from '~/shared/hooks/useLocalStorage'

const InterfaceNav: FC = () => {
  const featureAccess = useFeatureAccess()
  const [inboxParams] = useLocalStorage('inboxParams')
  const [scheduleParams] = useLocalStorage('scheduleParams')

  return (
    <Box
      sx={{
        width: 100,
        paddingTop: 2,
        borderRight: 'solid',
        borderRightWidth: '.2rem',
        borderColor: 'grey.100',
        overflow: 'auto',
        '& a': {
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          flexDirection: 'column',
          height: '10rem',
          textDecoration: 'none',
          color: 'grey.400',
          textAlign: 'center',
          '&:hover, &.active': { color: 'text.primary', fontWeight: 'bold' },
        },
        '& a svg': { width: 30, height: 30, marginBottom: '0.5rem' },
      }}
    >
      <BehindProviderFeatureAccessCheck feature="tasks" featureAccess={featureAccess}>
        <NavLink to={inboxParams ? `/inbox${inboxParams ?? ''}` : '/inbox'}>
          <CheckCircleOutlineIcon />
          To Dos
        </NavLink>
      </BehindProviderFeatureAccessCheck>

      <NavLink to="/members">
        <FaceIcon />
        Members
      </NavLink>

      <BehindProviderFeatureAccessCheck feature="worklists" featureAccess={featureAccess}>
        <NavLink to="/worklist">
          <FormatListBulletedIcon />
          Worklists
        </NavLink>
      </BehindProviderFeatureAccessCheck>

      <NavLink to={scheduleParams ? `/schedule${scheduleParams ?? ''}` : '/schedule'}>
        <CalendarToday />
        Appointment Calendar
      </NavLink>
    </Box>
  )
}

export default InterfaceNav
